// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__BugfP","Logo":"Toolbar_Logo__13YP0","DesktopOnly":"Toolbar_DesktopOnly__1YQJ6"};